import { SectionHeading } from "./SectionHeading";
import { VideoEmbed } from "./VideoEmbed";
import { Reveal } from "./Reveal";

const TESTIMONIALS = [
  {
    name: "Filippo",
    videoId: "i8JC8mgn9-o",
    testid: "testimonial-filippo",
  },
  {
    name: "Ilaria",
    videoId: "xJ9ZbckiPK0",
    testid: "testimonial-ilaria",
  },
];

export const TestimonialsSection = () => (
  <section id="testimonianze" className="bg-[#121212] py-24 sm:py-32">
    <div className="mx-auto max-w-5xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Testimonianze video reali"
        title="Persone reali. Percorsi reali."
        testid="testimonials-heading"
      />
      <div className="grid gap-10 sm:grid-cols-2 sm:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.1 * i}>
            <figure
              data-testid={t.testid}
              className="mx-auto max-w-[300px] rounded-sm border border-[#C9A45C]/40 bg-[#080808] p-3"
            >
              <VideoEmbed
                videoId={t.videoId}
                title={`Testimonianza di ${t.name}`}
                aspect="9:16"
                testid={`${t.testid}-player`}
              />
              <figcaption className="px-2 py-4 text-center">
                <p className="font-display text-xl font-semibold text-[#C9A45C]">
                  {t.name}
                </p>
                <p className="mt-1 text-xs uppercase tracking-widest text-white">
                  Membro della Community Tempio Vivo
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 text-center">
        <p className="mb-6 text-sm font-semibold uppercase tracking-[0.2em] text-[#B8B8B8]">
          Anche tu puoi iniziare il tuo percorso.
        </p>
        <a
          data-testid="testimonials-community-button"
          href="#offerte"
          className="inline-flex items-center justify-center rounded-sm border-2 border-[#C9A45C] bg-transparent px-8 py-4 text-xs font-bold uppercase tracking-widest text-[#C9A45C] transition-colors duration-300 hover:bg-[#C9A45C]/10 sm:text-sm"
        >
          Scopri la Community Coaching
        </a>
      </Reveal>
    </div>
  </section>
);
